import { Modal, Text } from "$components";
import { useStyles } from "../styles/EDBForm.styles";
import useEDBFormHandlers from "../hooks/useEDBFormHandlers";
import { useEDBFormContext } from "../context/EDBFormContext";

export default function DeleteModal({ idEdb }: any) {
  const classes = useStyles();

  const { handleDelete } = useEDBFormHandlers();
  const { openDeleteEDBModal, setOpenDeleteEDBModal } = useEDBFormContext();

  return (
    <Modal
      textValidate="Supprimer"
      textCancel="Annuler"
      open={openDeleteEDBModal}
      onValidate={() => handleDelete(idEdb)}
      onCancel={() => setOpenDeleteEDBModal(false)}
    >
      <div className={classes.dialogContent}>
        <Text>
          Attention
          <br />
          Vous êtes sur le point de supprimer définitivement cette Expression de
          besoin.
          <br />
          Êtes-vous sûr de vouloir continuer ?
        </Text>
      </div>
    </Modal>
  );
}
